export default __webpack_public_path__ + "static/media/link.e72e6e38.png";